import { createAction } from 'redux-actions';

export const getPhotos = createAction('GET_PHOTOS');
export const getPhotosSuccess = createAction('GET_PHOTOS_SUCCESS', photos => ({ photos }));
export const getPhotosFail = createAction('GET_PHOTOS_FAIL', error => ({ error }));

export const getUsers = createAction('GET_PHOTO_USERS');
export const getUsersSuccess = createAction('GET_PHOTO_USERS_SUCCESS', users => ({ users }));
export const getUsersFail = createAction('GET_PHOTO_USERS_FAIL', error => ({ error }));

export const searchPhotos = createAction('SEARCH_PHOTOS', query => ({ query }));
export const searchPhotosSuccess = createAction('SEARCH_PHOTOS_SUCCESS', photos => ({ photos }));
export const searchPhotosFail = createAction('SEARCH_PHOTOS_FAIL', error => ({ error }));

export const getPhotoById = createAction('GET_PHOTO_BY_ID', id => ({ id }));
export const getPhotoByIdSuccess = createAction('GET_PHOTO_BY_ID_SUCCESS', current => ({ current }));
export const getPhotoByIdFail = createAction('GET_PHOTO_BY_ID_FAIL', error => ({ error }));

export const addPhoto = createAction('ADD_PHOTO', photo => ({ photo }));
export const addPhotoSuccess = createAction('ADD_PHOTO_SUCCESS', photo => ({ photo }));
export const addPhotoFail = createAction('ADD_PHOTO_FAIL', error => ({ error }));

export const updatePhoto = createAction('UPDATE_PHOTO', photo => ({ photo }));
export const updatePhotoSuccess = createAction('UPDATE_PHOTO_SUCCESS', photo => ({ photo }));
export const updatePhotoFail = createAction('UPDATE_PHOTO_FAIL', error => ({ error }));

export const setPhotoCount = createAction('SET_PHOTO_COUNT', count => ({ count }));
export const setPhotoPage = createAction('SET_PHOTO_PAGE', page => ({ page }));
export const setPhotoQuery = createAction('SET_PHOTO_QUERY', query => ({ query }));
